import React, { useState } from "react";
import "./CommentSection.scss";
import DynaInput from "../DynaView/DynaInput";
import DynaButton from "../DynaView/DynaButton";
import pic from "../../Assets/images/image 2.png";
import DynamikStarRating from "../StarRating/DynamikStarRating";
import axios from "axios";
import { toast } from "react-toastify";
import { prefixUrl } from "../../Utils/utilsData";

const CommentSection = ({
  showStarRating,
  detailBlog,
  blogId,
  reload,
  setReload,
  type,
}) => {
  const [values, setValues] = useState({
    text: "",
    score: "",
  });
  const [formValid, setFormValid] = useState({
    text: true,
  });
  const comment = detailBlog.comments;

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setValues({
      ...values,
      [name]: value,
    });
  };
  const scoreHandler = (value) => {
    setValues((prevState) => ({
      ...prevState,
      score: value,
    }));
  };
  const handleCommentSubmit = async () => {

    if (values.text === "") {
      toast.error("نظر خود را ثبت کنید");
      return;
    }
    //blog Mode
    let formData;
    let url;
    if (type === 1) {
      url = `${prefixUrl()}/blog/addComment.php`;
      formData = {
        blogId: blogId.id,
        text: values.text,
        score: values.score,
      };
    } else if (type === 2) {
      //product mode
      url = `${prefixUrl()}/product/addComment.php`;
      formData = {
        productId: blogId,
        text: values.text,
        score: values.score,
      };
    }
    try {
      const response = await axios.post(url, formData);

      if (response.data.status === false) {
        toast.error(response.data.message);
      }

      if (response.data.status === true) {
        setValues({
          ...values,
          text: "",
        });
        if (type === 2) {
          setReload(Math.random());
        }
        toast.success("نظر شما ثبت شد و پس از بررسی منتشر می شود.");
      }
    } catch (error) {
      console.error("Error submitting comment:", error);
    }
  };

  return (
    <div className="comment-section">
      <div className="show-comment">
        <p className="title-comment">{detailBlog.numberComment} دیدگاه</p>

        {comment?.map((commentItem) => (
          <div className="current-comment" key={commentItem.id}>
            <img src={pic} alt="" />
            <div className="text-side">
              <h5>{commentItem.userName}</h5>
              <h6>{commentItem.date}</h6>
              <p>{commentItem.text}</p>
            </div>
          </div>
        ))}
      </div>

      <div className="sent-comment">
        <p className="title-comment">افزودن دیدگاه</p>

        {showStarRating && (
          <div className="DynamikStarRating">
            <label>امتیاز</label>
            <DynamikStarRating setRating={scoreHandler} />
          </div>
        )}

        <DynaInput
          typeMode={"textarea"}
          name="text"
          id="textId"
          label="دیدگاه"
          type="text"
          placeholder="دیدگاه  خود را وارد کنید"
          className={`ordibehesht-type ${
            formValid.text ? "" : "solid-login-type-error"
          }`}
          value={values?.text}
          onChange={handleInputChange}
        />

        <div className="button-comment">
          <DynaButton className="brown-but" onClick={handleCommentSubmit}>
            ارسال دیدگاه
          </DynaButton>
        </div>
      </div>
    </div>
  );
};
export default CommentSection;
